import { type BasePromotionCategoryRepository } from "../../_Bases/BasePromotionCategoryRepository";
import { type LocalDatabasePromotionCategory } from "../../_Bases/BasePromotionCategoryRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBPromotionCategoryRepository extends BaseIndexedDBRepository<
    LocalDatabasePromotionCategory
> implements BasePromotionCategoryRepository {
    public readonly source: InternalIndexedDBDatabase["promotionCategories"];
    protected readonly dataTypeName = "Promotion Category";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.promotionCategories;
    }

    public search(value: string): Promise<Array<LocalDatabasePromotionCategory>> {
        const needle = value.trim().toLowerCase();

        return this.source
            .filter(classification => {
                return classification.name.toLowerCase().includes(needle);
            })
            .toArray();
    }
}
